export const MAPPED_NOTIFICATIONS = {
  "jobs-unassigned": "jobsUnassigned",
  "orders-unassigned": "ordersUnassigned",
  "unhandeled-next-point-requests": "nextPointRequests",
  "unchecked-customer-changed-location": "customerChangedLocation",
  "pending-retailer-updates": "retailerUpdates",
  "pending-retailer-templates": "retailerTemplates",
  "unread-ticket-messages": "unreadTicketMessages",
};
